import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {bill} from '../../services/api/api'
// Models

interface iBill {[key:number]:bill[] |null}
// Bills state
export interface billsState {
    isLoaded: boolean, // First load
    isLoading: boolean, // On filtering laoder
    isFetching: boolean,
    hasMore: boolean,
    bills: iBill,
    page:number
}

const initialBillsState: billsState = {
    isLoaded: false,
    isLoading: false,
    isFetching: false,
    hasMore: true,
    bills: {
        1:[]
},
    page:1
}

// Bills slice
export const billsSlice = createSlice({
    name: 'bills',
    initialState: initialBillsState,
    reducers: {
        setIsLoaded: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isLoaded = payload
        },
        setIsLoading: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isLoading = payload
        },
        setIsFetching: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isFetching = payload
        },
        setHasMore: ( state, {payload}: PayloadAction<boolean> ) => {
            state.hasMore = payload
        },
        initializeBills: ( state, {payload}: PayloadAction<bill[]> ) => {
            state.bills[state.page] = [...payload]
        },
        addBills: ( state, {payload}: PayloadAction<bill[]> ) => {
            state.bills[state.page] =state.bills[state.page]?
             [ ...(state.bills[state.page]??[]), ...payload ]: [...payload]
        },
        updateBill: ( state, {payload}: PayloadAction<bill> ) => {
            let index = state.bills[state.page]!.findIndex( bill => bill.id === payload.id )
            if( index&&index !== -1 )
            state.bills[state.page]![index] = payload
        },
        deleteBills: ( state, {payload}: PayloadAction<number[]> ) => {
            payload.map(id => {
                let index = state.bills[state.page]!.findIndex( bill => bill.id === id )
                if( index != -1 )
                state.bills[state.page]!.splice( index, 1 )
            })
        },
        setDeliveryOrderIssued:(state,action)=>{
            let target= state.bills[state.page]!.filter(ele=>ele.bill_no === action.payload.bill_no)[0]
           
            if (target) {
                target.delivery_order=action.payload.value?'1':'0'
            }
        },
        reset: ( state ) => {
            state.bills = []
            state.hasMore = true
        },
        setPage:(state,{payload}:PayloadAction<number>)=>{
            state.page=payload
        }
    }
})